"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInCategoryHierarchy = exports.flattenNestedGroupings = exports.convertAndSortGroupingByKey = exports.capGrouping = exports.convertAndSortGrouping = exports.getReportSpecificFilterFromReportName = exports.getGroupingKeys = exports.getGroupingKeysForCoa = exports.normalizeCategory = exports.constructDatePeriods = void 0;
const immutable_1 = require("immutable");
const lodash_1 = __importDefault(require("lodash"));
const store_1 = __importDefault(require("store"));
const reportsUtils_1 = require("companion-app-components/flux/reports/reportsUtils");
const retrievers_1 = require("data/accounts/retrievers");
const getSplitItems = (txn) => {
    var _c;
    const items = (_c = txn.split) === null || _c === void 0 ? void 0 : _c.items;
    if (!items)
        return [];
    if (Array.isArray(items))
        return items;
    return items.toArray();
};
const constructDatePeriods = (dateRange, timeStep, useEndOfPeriod = false) => {
    var _c, _d, _e, _f, _h, _j;
    if (!dateRange || !timeStep) {
        return (0, immutable_1.List)();
    }
    if (timeStep === 'none') {
        const singlePeriodDate = useEndOfPeriod
            ? (_c = dateRange.end) === null || _c === void 0 ? void 0 : _c.toISO()
            : (_d = dateRange.start) === null || _d === void 0 ? void 0 : _d.toISO();
        return (0, immutable_1.List)([
            {
                timeStamp: singlePeriodDate,
                total: 0,
            },
        ]);
    }
    const timeStepWithoutS = timeStep.replace('s', '');
    let dateTicker = (useEndOfPeriod ? (_e = dateRange.start) === null || _e === void 0 ? void 0 : _e.endOf(timeStepWithoutS) : (_f = dateRange.start) === null || _f === void 0 ? void 0 : _f.startOf(timeStepWithoutS));
    const endDate = (useEndOfPeriod ? (_h = dateRange.end) === null || _h === void 0 ? void 0 : _h.endOf(timeStepWithoutS) : (_j = dateRange.end) === null || _j === void 0 ? void 0 : _j.endOf(timeStepWithoutS));
    const dateTimeIncrement = { [timeStep]: 1 };
    return (0, immutable_1.List)().withMutations((boi) => {
        var _c;
        if (dateTicker && endDate) {
            while (dateTicker <= endDate) {
                const period = {
                    timeStamp: (_c = dateTicker.toISO()) !== null && _c !== void 0 ? _c : '',
                    total: 0,
                };
                boi.push(period);
                dateTicker = dateTicker.plus(dateTimeIncrement);
            }
        }
    });
};
exports.constructDatePeriods = constructDatePeriods;
const normalizeCategory = (catName) => {
    if (!catName)
        return null;
    const withoutSymbols = catName.replace(/[{}]/g, ' '); // remove braces & parentheses
    const withNormalizedWhiteSpace = withoutSymbols.replace(/\s+/g, ' '); // change groups of whitespace to a single one
    return withNormalizedWhiteSpace.trim(); // trim excess whitespace from the start and end
};
exports.normalizeCategory = normalizeCategory;
const getGroupingKeysForCoa = (txn, split, _groupBy, categoriesById) => {
    var _c, _d;
    const addParentCoa = (parentList, txnCat, txnCatId, parentCategoryId) => {
        var _c;
        parentList.push(Object.assign(Object.assign({ groupKey: (0, exports.normalizeCategory)(txnCat.name), categoryId: (_c = txnCat.id) !== null && _c !== void 0 ? _c : '', isTxnCategory: txnCat.id === txnCatId }, (parentCategoryId ? { parentCategoryId } : {})), { total: 0, childTotal: 0, txns: [] }));
    };
    const buildParentCoaList = (parentList, txnCat, txnCatId) => {
        if ((txnCat === null || txnCat === void 0 ? void 0 : txnCat.parentId) === '0') {
            if (txnCat) {
                addParentCoa(parentList, txnCat, txnCatId);
            }
            return parentList;
        }
        const parentCat = (txnCat ? categoriesById.get(txnCat.parentId, txnCatId) : undefined);
        if (txnCat) {
            addParentCoa(parentList, txnCat, txnCatId, (parentCat === null || parentCat === void 0 ? void 0 : parentCat.id) || txnCat.id);
        }
        return buildParentCoaList(parentList, parentCat, txnCatId);
    };
    const txnItem = txn.split ? split : txn;
    const txnCat = ((_c = txnItem.coa) === null || _c === void 0 ? void 0 : _c.type) === 'CATEGORY' ? categoriesById.get(txnItem.coa.id) : null;
    const catList = txnCat ? buildParentCoaList([], txnCat, (_d = txnItem.coa) === null || _d === void 0 ? void 0 : _d.id) : [];
    if (txnCat) {
        return catList;
    }
    return [{
            groupKey: 'Uncategorized',
            subKey: 'Uncategorized',
            categoryId: '0',
            isTxnCategory: true,
            total: 0,
            childTotal: 0,
            txns: [],
            subgroups: [],
        }]; // not categorized
};
exports.getGroupingKeysForCoa = getGroupingKeysForCoa;
const getGroupingKeys = (txn, split, groupBy, categoriesById, tagsById) => {
    var _c, _d, _e, _f;
    const getRootCoaId = (txnCat) => {
        if (!txnCat)
            return null;
        if ((txnCat === null || txnCat === void 0 ? void 0 : txnCat.parentId) === '0') {
            return txnCat;
        }
        return getRootCoaId(categoriesById.get(txnCat.parentId));
    };
    switch (groupBy) {
        case 'categories':
        case 'category': {
            const txnItem = txn.split ? split : txn;
            const txnCat = ((_c = txnItem.coa) === null || _c === void 0 ? void 0 : _c.type) === 'CATEGORY' ? categoriesById.get(txnItem.coa.id) : null;
            const parentCat = txnCat ? getRootCoaId(txnCat) : null;
            if (txnCat) {
                return {
                    groupKeys: [parentCat ? (0, exports.normalizeCategory)(parentCat.name) : (0, exports.normalizeCategory)(txnCat.name)],
                };
            }
            return { groupKeys: ['Uncategorized'] }; // not categorized
        }
        case 'payees':
        case 'payee': {
            return {
                groupKeys: [(0, reportsUtils_1.normalizePayee)(txn.payee) || 'no payee'],
                subKey: null,
                originalKey: txn.payee || 'no payee',
            };
        }
        case 'tags':
        case 'tag': {
            // @ts-expect-error - FIXME: This expression is not callable.
            const tagGroupKeys = (_f = (_e = (_d = split.tags) === null || _d === void 0 ? void 0 : _d.map((tag) => { var _c; return ((_c = tagsById.get(tag.id)) === null || _c === void 0 ? void 0 : _c.name) || null; }).filter((val) => val !== null)) === null || _e === void 0 ? void 0 : _e.toJS) === null || _f === void 0 ? void 0 : _f.call(_e);
            return {
                groupKeys: tagGroupKeys && tagGroupKeys.length > 0 ? tagGroupKeys : ['Untagged'],
                subKey: null,
            };
        }
        default: {
            return { groupKeys: ['total'], subKey: null };
        }
    }
};
exports.getGroupingKeys = getGroupingKeys;
// helpers for getReportSpecificFilterFromReportName, returning true means keep
const spendingFilter = (txn, categoriesById) => {
    var _c, _d;
    const splitItems = getSplitItems(txn);
    if (splitItems.length > 0) {
        return splitItems.some((split) => spendingFilter(split, categoriesById));
    }
    if (!txn.coa && !((_c = txn.split) === null || _c === void 0 ? void 0 : _c.items)) {
        return false;
    }
    if (((_d = txn.coa) === null || _d === void 0 ? void 0 : _d.type) && txn.coa.type === 'UNCATEGORIZED') {
        return true;
    }
    const category = txn.coa ? categoriesById === null || categoriesById === void 0 ? void 0 : categoriesById.get(txn.coa.id) : undefined;
    return (category && category.type === 'EXPENSE') || false;
};
const incomeFilter = (txn, categoriesById) => {
    const splitItems = getSplitItems(txn);
    if (splitItems.length > 0) {
        return splitItems.some((split) => incomeFilter(split, categoriesById));
    }
    if (!txn.coa) {
        return false;
    }
    const category = categoriesById === null || categoriesById === void 0 ? void 0 : categoriesById.get(txn.coa.id);
    return (category && category.type === 'INCOME') || false;
};
const noUpcomingFilter = (txn) => txn.source !== 'SCHEDULED_TRANSACTION_PENDING';
const keepAll = () => true;
const netIncomeFilter = (txn, categoriesById) => incomeFilter(txn, categoriesById) || spendingFilter(txn, categoriesById);
function getReportSpecificFilterFromReportName(reportName) {
    switch (reportName) {
        case 'spending':
            return spendingFilter;
        case 'net-income':
            return netIncomeFilter;
        case 'income':
            return incomeFilter;
        case 'net-worth':
        case 'savings':
            return noUpcomingFilter;
        default:
            return keepAll;
    }
}
exports.getReportSpecificFilterFromReportName = getReportSpecificFilterFromReportName;
// takes a grouping object from getTotalData and converts subgroups into sorted lists
function convertAndSortGrouping(groupObject, sign) {
    return Object.entries(groupObject)
        .sort(([_a, a], [_b, b]) => sign * b.total - sign * a.total)
        .map(([_g, group]) => {
        var _c, _d;
        const convertedSubgroup = convertAndSortGrouping(group.subgroups || {}, sign);
        return Object.assign(Object.assign({}, group), { subgroups: convertedSubgroup, total: sign * group.total, currency: (0, retrievers_1.getCurrencyString)((_d = (_c = group === null || group === void 0 ? void 0 : group.txns) === null || _c === void 0 ? void 0 : _c.first()) === null || _d === void 0 ? void 0 : _d.accountId, store_1.default.getState()) });
    });
}
exports.convertAndSortGrouping = convertAndSortGrouping;
// expects a list of groups with lists of subgroups and caps them to a specific length
function capGrouping(uncappedGrouping, cap, overflowGroupName) {
    const cappedGrouping = [];
    const txns = [];
    let total = 0;
    if (uncappedGrouping.length <= cap) {
        uncappedGrouping.forEach((group) => {
            cappedGrouping.push(group);
            const txnsToPush = group.txns || [];
            txns.push(...txnsToPush);
            total += group.total;
        });
    }
    else { // here we need to do some work
        for (let i = 0; i < cap - 1; i++) { // first go through and add groups that aren't changing
            const group = uncappedGrouping[i];
            cappedGrouping.push(group);
            total += group.total;
            const txnsToPush = group.txns || [];
            txns.push(...txnsToPush);
        }
        // add in the overflow group
        const [subGroup, subTxns, subTotal] = capGrouping(uncappedGrouping.slice(cap - 1), cap, overflowGroupName);
        total += subTotal;
        txns.push(...subTxns);
        cappedGrouping.push({ groupKey: overflowGroupName, total: subTotal, txns: subTxns, subgroups: subGroup });
    }
    // when groups are created in the selector 'getTotalData' a txn can technically end up in multiple groups because
    //  of splits and multiple tags, this iterates over and removes the duplicates by id
    // TODO: do we need to adjust the total tho?
    const uniqueTxns = (0, immutable_1.List)(lodash_1.default.uniqBy(txns, (e) => e.id));
    return [cappedGrouping, uniqueTxns, total];
}
exports.capGrouping = capGrouping;
// takes a grouping object from getTotalData and converts subgroups into sorted by groupKey
const convertAndSortGroupingByKey = (groupObject, sign) => Object.entries(groupObject).sort(([_a, a], [_b, b]) => { var _c, _d, _e, _f; return (_f = (_d = (_c = a.groupKey) === null || _c === void 0 ? void 0 : _c.localeCompare) === null || _d === void 0 ? void 0 : _d.call(_c, (_e = b.groupKey) !== null && _e !== void 0 ? _e : '')) !== null && _f !== void 0 ? _f : 0; })
    .map(([_g, group]) => {
    var _c, _d;
    const convertedSubgroup = (0, exports.convertAndSortGroupingByKey)(group.subgroups || {}, sign);
    return Object.assign(Object.assign({}, group), { subgroups: convertedSubgroup, total: sign * group.total, currency: (0, retrievers_1.getCurrencyString)((_d = (_c = group === null || group === void 0 ? void 0 : group.txns) === null || _c === void 0 ? void 0 : _c.first()) === null || _d === void 0 ? void 0 : _d.accountId, store_1.default.getState()) });
});
exports.convertAndSortGroupingByKey = convertAndSortGroupingByKey;
const flattenNestedGroupings = (nodes, categoryId = null, indentation = 1) => {
    let arrFlattened = [];
    nodes.forEach((node) => {
        var _c;
        if (node.categoryId === categoryId) {
            return;
        }
        const newNode = Object.assign({}, node);
        newNode.parentId = categoryId; // Assign parentId to the current node
        newNode.indentation = indentation; // Assign the current indentation level
        arrFlattened.push(newNode);
        // If the node has subgroups, recursively call the function for the subgroups
        if (Array.isArray(newNode.subgroups) && newNode.subgroups.length) {
            arrFlattened = arrFlattened.concat((0, exports.flattenNestedGroupings)(newNode.subgroups, (_c = newNode.categoryId) !== null && _c !== void 0 ? _c : null, indentation + 1)); // Increment indentation for subgroups
            delete newNode.subgroups; // Remove the subgroups property after flattening
        }
    });
    return arrFlattened;
};
exports.flattenNestedGroupings = flattenNestedGroupings;
const isInCategoryHierarchy = (categoryId, parentCategoryId, categoriesById) => {
    if (!parentCategoryId || parentCategoryId === '')
        return false;
    if (categoryId === parentCategoryId)
        return false;
    let current = categoriesById.get(categoryId);
    while (current && current.parentId && current.parentId !== '0') {
        if (current.parentId === current.id)
            return false;
        if (current.parentId === parentCategoryId)
            return true;
        current = current.parentId ? categoriesById.get(current.parentId) : undefined;
    }
    return false;
};
exports.isInCategoryHierarchy = isInCategoryHierarchy;
